import { BalanceFeatureToggleV2 } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'

interface BalanceContainerProps {
  x: number
  y: number
}

export const BalanceContainer = (props: BalanceContainerProps) => {
  return (
    <BalanceFeatureToggleV2
      x={props.x}
      y={props.y}
      width={500}
      height={116}
      currencyStyle={textCurrencyStyle}
      titleStyle={textTitleStyle}
      amountStyle={textAmountStyle}
    />
  )
}

const textCurrencyStyle = new TextStyle({
  fontSize: 24,
  fill: '#7B7B7B',
  align: 'left',
  stroke: '#7B7B7B',
  strokeThickness: 1.5,
})
/** 與餘額標題列一致，供其他 UI（如 tumble bar 標題）沿用字族。 */
export const balancePanelTitleFontFamily = 'Roboto, Arial, sans-serif'

const textTitleStyle = new TextStyle({
  fontFamily: balancePanelTitleFontFamily,
  fontSize: 38,
  fill: '#FFD154',
  align: 'center',
  stroke: '#FFD154',
  strokeThickness: 2,
  letterSpacing: 2,
})
const textAmountStyle = new TextStyle({
  fontSize: 38,
  fill: '#FFFFFF',
  align: 'center',
})
